import { ArrowRight } from "lucide-react";
import { Button } from "./ui/Button";
import AuthRedirect from "./AuthRedirect";

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16">
      {/* Background */}
      <div className="absolute inset-0 -z-10">
        <div className="w-full h-full bg-gradient-to-br from-background via-background/95 to-primary/10" />
      </div>

      {/* Animated circles */}
      <div className="absolute top-20 right-20 w-64 h-64 rounded-full bg-primary/20 blur-3xl animate-float" />
      <div className="absolute bottom-20 left-20 w-96 h-96 rounded-full bg-accent/20 blur-3xl animate-float" style={{ animationDelay: "2s" }} />

      <div className="container mx-auto px-4 py-20 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass border border-primary/20">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
            </span>
            <span className="text-sm font-medium">Tu asistente inmobiliario con IA</span>
          </div>

          {/* Main heading */}
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight">
            Comprar un piso es una{" "}
            <span className="inline-block">💩</span>
            <br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary via-accent to-primary animate-glow">
              Ahora un poco menos
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-muted-foreground max-w-2xl mx-auto">
            GABI, tu asistente inmobiliario con IA, te guía paso a paso para dejar de buscar piso a ciegas.
          </p>

          {/* CTA Question */}
          <div className="max-w-2xl mx-auto space-y-6">
            <h2 className="text-2xl md:text-3xl font-bold">
              ¿Qué te falta para comprarte la vivienda de tus sueños?
            </h2>
            <AuthRedirect>
              <Button variant="hero" size="xl" className="gap-2">
                Pruébalo Ya
                <ArrowRight className="w-5 h-5" />
              </Button>
            </AuthRedirect>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 pt-8 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              ✅ <span>Análisis en segundos</span>
            </div>
            <div className="flex items-center gap-2">
              ✅ <span>Informes claros y sin tecnicismos</span>
            </div>
            <div className="flex items-center gap-2">
              ✅ <span>Alternativas reales si no tienes ahorros</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
